/* Support desk page styles (shared by the list and the conversation page). */

export const PAGE = "h-full min-w-0 flex-1 overflow-y-auto bg-[#F7F8FA]";
export const PAGE_INNER =
  "mx-auto max-w-[1280px] px-4 py-6 sm:px-8 sm:py-[30px]";
export const SMALL_BUTTON =
  "h-9 rounded-lg border border-[#DCE2EA] bg-white px-3.5 text-[13px] font-semibold text-[#1F2433] hover:bg-[#F8F9FB] disabled:cursor-not-allowed disabled:opacity-60";
export const PRIMARY_BUTTON =
  "h-9 rounded-lg bg-[#6B4EFF] px-4 text-[13px] font-semibold text-white hover:bg-[#5A3EEB] disabled:cursor-not-allowed disabled:opacity-60";
